import * as React from "react";
import styles from "./Card.module.scss";

const Card = ({ logo, count, title }) => {
  return (
    <div className={['col-md-3', styles.cardContainer].join(' ')}>
      <div className={styles.card}>
        <div className={'mr-2'}>
          { logo }
        </div>
        <div className={'d-flex justify-content-center flex-column'}>
          <div className={styles.count}>
            { count }
          </div>
          <div className={styles.title}>
            { title }
          </div>
        </div>
      </div>
    </div>
  )
}

export default Card